import { clients } from 'lib/https';
import {
  IAgentConversationByIdPayload,
  IAgentConversationByIdResponse,
  IAgentConversationListPayload,
  IAgentConversationListResponse,
} from '../types/agent-conversation.types';
import { getConfigurationSettings } from 'services/configuration-service';

export class AgentConversationService {
  async getAgentConversationList(
    payload: IAgentConversationListPayload,
    blocksKey: string
  ): Promise<IAgentConversationListResponse> {
    // Agent chats now live in the unified Conversations collection. List them via the
    // collaboration conversation list filtered by agentId, and adapt the result back into
    // the session-summary shape the sidebar already consumes (it reads conversation.Title).
    const config = await getConfigurationSettings();
    const body = {
      agentId: payload.agent_id,
      page: (payload.offset ?? 0) + 1,
      pageSize: payload.limit ?? 20,
      isArchived: false,
      // Sidebar history shows real chats; preview/test conversations are shown separately.
      test: false,
    };
    const res = (await clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.collaborationConversation}`,
      blocksKey,
      JSON.stringify(body)
    )) as { data?: any[]; totalCount?: number };
    const list = res?.data ?? [];
    const totalCount = res?.totalCount ?? list.length;
    const sessions = list.map((conv: any) => ({
      agent_id: payload.agent_id,
      widget_id: conv.participants?.[payload.agent_id ?? '']?.widgetId ?? '',
      session_id: conv.conversationId,
      created_at: conv.createdDate,
      last_entry_date: conv.lastUpdatedDate,
      total_count: totalCount,
      conversation: {
        SessionId: conv.conversationId,
        Title: conv.conversationTitle,
        ConversationType: 'chat',
      },
    }));
    return { sessions, total_count: totalCount } as unknown as IAgentConversationListResponse;
  }

  async getAgentConversationSessionById(
    payload: IAgentConversationByIdPayload,
    blocksKey: string
  ): Promise<IAgentConversationByIdResponse> {
    // Open one agent conversation's messages from the unified collaboration store.
    const config = await getConfigurationSettings();
    const res = (await clients.post(
      `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.getCollaborationMessages}`,
      blocksKey,
      JSON.stringify({ conversationId: payload.session_id, pageSize: 200 })
    )) as { data?: any[]; totalCount?: number };
    const messages = res?.data ?? [];
    return {
      sessions: messages as unknown as IAgentConversationByIdResponse['sessions'],
      total_count: res?.totalCount ?? messages.length,
    };
  }
}

export const agentConversationService = new AgentConversationService();
